<template>
  <div class="min-h-screen flex flex-col bg-gradient-to-br from-primary-50 via-white to-blue-50">
    <TopBar />
    <Header />
    <div class="flex-1 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div class="w-full max-w-md">
        <router-view></router-view>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script setup lang="ts">
import TopBar from "@/domains/auth/TopBar.vue"
import Footer from "@/domains/auth/Footer.vue"
import Header from "@/domains/auth/Header.vue";
</script>
